import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { CompareFactor } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { Chip, SxProps, Theme } from '@mui/material';

import { factorLabel, percent } from '../compare.util';

const STRINGS = appStrings.modules.myColleges.compare;

type WeightBadgeProps = Readonly<{
  factor: CompareFactor;
  share: number;
  onClick: (factor: CompareFactor) => void;
}>;

export const WeightBadge = ({ factor, share, onClick }: WeightBadgeProps) => (
  <Chip
    id={`compare-weight-badge-${factor}`}
    variant="badge"
    size="sm"
    label={STRINGS.share(percent(share))}
    aria-label={STRINGS.editWeight(factorLabel(factor))}
    onClick={() => onClick(factor)}
    sx={badgeSx}
  />
);

const badgeSx: SxProps<Theme> = ({ backrs }) => ({
  borderColor: backrs.colors['Colors/Border/border-primary'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  boxShadow: backrs.shadows['shadow-xs'],
  color: backrs.colors['Colors/Text/text-secondary'],
  cursor: 'pointer',
  '&:hover': { borderColor: backrs.colors['Brand/500'] },
});
